import { useTranslation } from 'react-i18next';

import { AccessoryTabProps } from 'components/desktop/Accessory/AccessoryComponent';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import UnitWeightEditor from 'components/desktop/_general/UnitWeightEditor/UnitWeightEditor';
import { Characteristic } from 'enums/characteristic';
import PERMISSIONS from 'enums/permissions';
import { arePermissionsInUserPermissions } from 'functions/tokenFunctions';
import * as UnitList from 'types/_general/Store/UnitList';

export const AccessoryUnitWeightsCard = ({
	state,
	handlers,
	data,
}: AccessoryTabProps): JSX.Element => {
	const { t } = useTranslation();
	const isAccessoryEditor: boolean = arePermissionsInUserPermissions([
		PERMISSIONS.WRITEACCESSORY,
	]);

	return (
		<FoldableCard
			defaultOpen={true}
			dataComponentType="accessory-unit-weights-card"
			title={t('_general:WEIGHT')}
			content={
				<div className="card-body">
					<UnitWeightEditor
						units={UnitList.mapToUnitLightList(
							UnitList.getByCharacteristic(
								data.units,
								state.characteristic ?? Characteristic.SolidNonQuantifiable
							)
						)}
						unitWeights={state.unitWeights}
						setUnitWeights={handlers.setUnitWeights}
						disabled={!isAccessoryEditor}
					/>
				</div>
			}
		/>
	);
};
